import { render, staticRenderFns } from "./broadBottom.vue?vue&type=template&id=b2c1b30c&scoped=true&"
import script from "./broadBottom.vue?vue&type=script&lang=js&"
export * from "./broadBottom.vue?vue&type=script&lang=js&"
import style0 from "./broadBottom.vue?vue&type=style&index=0&id=b2c1b30c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c1b30c",
  null
  
)

export default component.exports